export const CREATE_CONTACT_START = 'CREATE_CONTACT_START';

export const CREATE_CONTACT_SUCCESS = 'CREATE_CONTACT_SUCCESS';

export const CREATE_CONTACT_FAILURE = 'CREATE_CONTACT_FAILURE';
